/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button } from '../button/button';

import OrganizationSubscriptionService from '../../utilities/services/organization-subscription-service';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import { Dialog } from '@headlessui/react';
import PortalProgressBar from '../portal-progress-bar/portal-progress-bar';
import { Organization } from '../../models/interfaces/organization';
import UserDeactivationModal from '../manage-users-modals/user-deactivation-modal';
import { AddOns } from '../../models/enumerations/add-ons';
import LicenseRemovalModal from '../manage-users-modals/license-removal-modal';
import { Loader } from '../loader/loader';
import moment from 'moment';
import FunctionService from '../../utilities/services/function-service';
import { AddOnId } from '../../models/enumerations/add-on-id';
import { CheckboxTypeInput } from '../forms/checkbox-type-input';
import { useForm } from 'react-hook-form';
import { NumberTypeInput } from '../forms/number-type-input/number-type-input';
import { useTranslation } from "react-i18next";
import DateUtil from '../../utilities/date-util';
import { OrganizationSubscription } from '../../models/interfaces/organization-subscription';
import BillingService from '../../utilities/services/billing-service';
import { createLogger } from '../../utilities/logger';

const log = createLogger("AddOnDialogBox");

interface AddOnDialogBoxProps {
  onClose: Function,
  imageUrl?: string,
  serviceName: string,
  addOnName?: string,
  price: number,
  description: string,
  descriptionBullets: string[],
  summaryDescription: string[],
  priceId: string,
  quantity: number,
  setAddOnPurchaseComplete?: Function,
  setAddOnRemoveComplete?: Function,
  removeAddOn: boolean,
  organization: Organization,
  nextPayment?: string,
  setAddOnRemovedModalOpen?: Function,
  setRemovedAddOnInfo?: Function,
  products: any[],
}
const AddOnDialogBox: React.FC<AddOnDialogBoxProps> = (props: AddOnDialogBoxProps) => {
  const COMPONENT_CLASS = 'c-add-on-dialog-box';
  const [showNextSlide, setShowNextSlide] = useState<boolean>(false);
  const [showManageUserSlide, setShowManageUserSlide] = useState<boolean>(false);
  const [showManageLicenseSlide, setShowManageLicenseSlide] = useState<boolean>(false);
  const { state } = useAuthState();
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(0);
  // Hidden limit is for when they have removed an amount of an add-on and we need to track there soon to be limit.
  const [hiddenLimit, setHiddenLimit] = useState<number>();
  const [existingAmountToBeRemoved, setExistingAmountToBeRemoved] = useState<number>(0);
  const {
    onClose,
    serviceName,
    addOnName,
    price,
    description,
    descriptionBullets,
    summaryDescription,
    priceId,
    quantity,
    setAddOnPurchaseComplete,
    setAddOnRemoveComplete,
    nextPayment,
    organization,
    setAddOnRemovedModalOpen,
    setRemovedAddOnInfo,
    products,
  } = props;
  const [prorationDate, setProrationDate] = useState<number>();
  const [proratedRate, setProratedRate] = useState<number>();
  const [fullRate, setFullRate] = useState<number>();
  const [refundedAmount, setRefundedAmount] = useState<number>();
  const [subscriptionItem, setSubscriptionItem] = useState<any>();
  const [subscription, setSubscription] = useState<any>();
  const [orgSub, setOrgSub] = useState<OrganizationSubscription>();
  const [addOnsToBeRemoved, setAddOnsToBeRemoved] = useState<string>("1");
  const [firstConditionChecked, setFirstConditionChecked] = useState<boolean>(false);
  const [secondConditionChecked, setSecondConditionChecked] = useState<boolean>(false)
  const [thirdConditionChecked, setThirdConditionChecked] = useState<boolean>(false)
  const [amountOfUnusedDays, setAmountOfUnusedDays] = useState<number>(0)
  const [subscriptionSchedule, setSubscriptionSchedule] = useState<any>(undefined);
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const { t } = useTranslation();
  const {
    register,
  } = useForm<any>();
  // Retrieve base data
  useEffect(() => {
    const retrieveBaseData = async () => {
      setProrationDate(Math.floor(Date.now() / 1000));

      await OrganizationSubscriptionService.getByOrganizationId(state.organization.id!).then(async (orgSub) => {
        await setOrgSub(orgSub[0]);

        if (orgSub[0].stripeAddOnSubscription) {
          const addOnDetails = await BillingService.getAddOnDetails({
            stripeAddOnSubscriptionId: orgSub[0].stripeAddOnSubscription,
          });

          setSubscription(addOnDetails);
          if (addOnDetails.schedule) {
            setSubscriptionSchedule(addOnDetails.schedule);
          }

          setSubscriptionItem(addOnDetails.items.find((item) => item.priceId === priceId));
        }
      });
    };

    retrieveBaseData();
  }, []);
  // Set Count/Limit
  useEffect(() => {
    const setCountLimit = () => {
      const phases: any[] = subscriptionSchedule?.phases || [];
      let toBeRemovedFromSchedule: number = 0
      // Get quantities with fallback to 0 if undefined
      const lastPhase = phases.at(-1) ?? undefined
      if (lastPhase?.end_date !== subscriptionSchedule?.current_phase?.end_date) {
        const lastItemQuantity: number = phases.at(-1)?.items.find((item: any) => item.price === priceId)?.quantity ?? 0;
        const secondLastItemQuantity: number = phases.at(-2)?.items.find((item: any) => item.price === priceId)?.quantity ?? 0;
        toBeRemovedFromSchedule = secondLastItemQuantity - lastItemQuantity
      }

      switch (addOnName) {
        case AddOns.User:
          // Check if specific addOn has a removal schedule already
          if (organization.userLimit) {
            setHiddenLimit(organization.userLimit - toBeRemovedFromSchedule)
            setExistingAmountToBeRemoved(toBeRemovedFromSchedule);
          }
          setCount(organization.userCount!);
          setLimit(organization.userLimit!);
          break;
        case AddOns.License:
          // Check if specific addOn has a removal schedule already
          if (organization.mySymmioLicense) {
            setHiddenLimit(organization.mySymmioLicense - toBeRemovedFromSchedule)
            setExistingAmountToBeRemoved(toBeRemovedFromSchedule);
          }
          setCount(organization.mySymmioLicenseCount!);
          setLimit(organization.mySymmioLicense!);
          break;
        case AddOns.Organization:
          // TODO FOR V2
          break;
      }
    }

    if (orgSub) {
      setCountLimit();
    }
  }, [orgSub, subscriptionSchedule])

  useEffect(() => {
    if (subscriptionItem) {
      calculateProration();
    }
  }, [subscriptionItem])


  const handleNextClick = () => {
    setShowNextSlide(true);
  };

  const handleManageUserSlide = () => {
    setShowManageUserSlide(true);
  }

  const handleManageLicenseSlide = () => {
    setShowManageLicenseSlide(true);
  }

  const handleRemove = async () => {
    if (!orgSub || !orgSub.stripeAddOnSubscription) {
      log.warn("Add-on removal blocked: no subscription data", {
        organizationId: organization?.id,
      });
      return;
    }
    setIsLoading(true);

    try {
      const removalResponse = await BillingService.scheduleAddOnRemoval({
        subscriptionId: orgSub.stripeAddOnSubscription,
        priceId,
        quantityToRemove: parseInt(addOnsToBeRemoved),
      });

      setAddOnRemoveComplete!(true);

      if (priceId === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id) {
        const removalData = {
          nextPaymentDate: moment(new Date(removalResponse.billingCycleEnd * 1000)).format('MMMM D Y'),
          removedUserCount: addOnsToBeRemoved,
          currentUserLimit: limit,
          reducedUserLimit: `${existingAmountToBeRemoved ? isNaN(parseInt(addOnsToBeRemoved)) ? '' : limit - parseInt(addOnsToBeRemoved) - existingAmountToBeRemoved : isNaN(parseInt(addOnsToBeRemoved)) ? '' : limit - parseInt(addOnsToBeRemoved)}`
        };
        FunctionService.sendAddOnUserRemovalEmail(state.user!, removalData);
      } else if (priceId === products.find((item) => item.product.id === AddOnId.License).prices.find((item: any) => item.data.active === true).id) {
        const removalData = {
          nextPaymentDate: moment(new Date(removalResponse.billingCycleEnd * 1000)).format('MMMM D Y'),
          removedLicenseCount: addOnsToBeRemoved,
          currentLicenseLimit: limit,
          reducedLicenseLimit: `${existingAmountToBeRemoved ? isNaN(parseInt(addOnsToBeRemoved)) ? '' : limit - parseInt(addOnsToBeRemoved) - existingAmountToBeRemoved : isNaN(parseInt(addOnsToBeRemoved)) ? '' : limit - parseInt(addOnsToBeRemoved)}`
        };
        FunctionService.sendAddOnLicenseRemovalEmail(state.user!, removalData);
      }

      log.info("Add-on removal scheduled", {
        organizationId: organization?.id,
        quantityToRemove: parseInt(addOnsToBeRemoved),
        addOn: priceId === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id ? "user" : "license",
      });

      setIsLoading(false);
      onClose();
      return removalResponse.billingCycleEnd;
    } catch (e) {
      log.error("Failed to schedule add-on removal", {
        exception: e,
        organizationId: organization?.id,
      });
      setIsLoading(false);
    }
  };
  const handlePayment = async () => {
    setIsLoading(true);

    if (!subscription || !subscriptionItem) {
      log.warn("Add-on purchase blocked: no subscription data", {
        organizationId: organization?.id,
      });
      setIsLoading(false);
      return;
    }

    try {
      const purchaseResponse = await BillingService.purchaseAddOn({
        subscriptionId: subscription.subscriptionId,
        subscriptionItemId: subscriptionItem.itemId,
        priceId,
        quantity: quantity + (subscriptionItem.quantity ?? 0),
        prorationDate: prorationDate ?? Math.floor(Date.now() / 1000),
      });

      setSubscription(purchaseResponse);
      if (purchaseResponse.schedule) {
        setSubscriptionSchedule(purchaseResponse.schedule);
      }

      if (priceId === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id) {
        const purchaseData = {
          nextPaymentDate: moment(new Date(purchaseResponse.currentPeriodEnd * 1000)).format('MMMM D Y'),
          addedUserCount: quantity,
          newUserLimit: limit + quantity,
        };
        FunctionService.sendAddOnUserConfirmationEmail(state.user!, purchaseData);
      } else if (priceId === products.find((item) => item.product.id === AddOnId.License).prices.find((item: any) => item.data.active === true).id) {
        const purchaseData = {
          nextPaymentDate: moment(new Date(purchaseResponse.currentPeriodEnd * 1000)).format('MMMM D Y'),
          addedLicenseCount: quantity,
          newLicenseLimit: limit + quantity,
        };
        FunctionService.sendAddOnLicenseConfirmationEmail(state.user!, purchaseData);
      }

      log.info("Add-on purchased", {
        organizationId: organization?.id,
        quantity,
        newLimit: limit + quantity,
        addOn: priceId === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id ? "user" : "license",
      });

      setAddOnPurchaseComplete!(true);
      setIsLoading(false);
      onClose();
    } catch (e) {
      log.error("Failed to purchase add-on", {
        exception: e,
        organizationId: organization?.id,
        quantity,
      });
      setIsLoading(false);
    }
  };
  // const calculateRefund = (): any | null => {
  //   const daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
  //   const daysUnused = daysInMonth - new Date().getDate();
  //   return { price: daysUnused !== 0 ? price - (price / daysInMonth) * daysUnused : null, day: daysUnused };
  // }
  // const refund = calculateRefund();
  const calculateProration = async () => {
    if (!subscription || !subscriptionItem || !prorationDate) {
      return;
    }

    try {
      const prorationResponse = await BillingService.calculateProration({
        subscriptionId: subscription.subscriptionId,
        subscriptionItemId: subscriptionItem.itemId,
        priceId,
        newQuantity: quantity,
        totalQuantity: quantity + (subscriptionItem.quantity ?? 0),
        prorationDate,
      });
      setProratedRate(prorationResponse.proratedRate);
      setRefundedAmount(prorationResponse.refundedAmount);
      setFullRate(prorationResponse.fullRate);

      if (subscription.current_period_start) {
        const start = typeof subscription.current_period_start === 'number'
          ? subscription.current_period_start
          : new Date(subscription.current_period_start).getTime() / 1000;
        setAmountOfUnusedDays(DateUtil.getDifferenceBetweenDate(parseInt(String(start))));
      }
    } catch (error) {
      log.error("Error calculating proration", {
        exception: error,
        organizationId: organization?.id,
      });
      setProratedRate(0);
      setRefundedAmount(0);
      setFullRate(0);
    }
  };

  const checkHandler = (num: number) => {
    switch (num) {
      case 1:
        setFirstConditionChecked(!firstConditionChecked);
        break;
      case 2:
        setSecondConditionChecked(!secondConditionChecked);
        break;
      case 3:
        setThirdConditionChecked(!thirdConditionChecked);
        break;
    }
  }

  const preventRemoveOverMax = (e: any) => {
    if (e.target.value > quantity - existingAmountToBeRemoved) {
      setAddOnsToBeRemoved((quantity - existingAmountToBeRemoved).toString());
    }
    else if (e.target.value === "") {
      setAddOnsToBeRemoved("NaN");
    }
    else {
      setAddOnsToBeRemoved(e.target.value);
    }
  };

  // This gets the pricing for the total quantity of an add-on.
  const getTotalPricingByPriceId = (totalQuantity: any, priceId: string) => {
    const price = products.find((item) => item.prices.find((price: any) => price.id === priceId)).prices.find((item: any) => item.data.active === true).data.unit_amount;
    return parseInt(isNaN(totalQuantity) ? 0 : totalQuantity) * price;
  }

  // This gets the pricing for the total quantity of an add-on.
  const getTotalPricingByPriceIdAndStripeQuantity = (addOnsToBeRemoved: any, priceId: string) => {
    if (!subscription) {
      return 0;
    }
    const phases: any[] = subscriptionSchedule?.phases || [];
    const quantity = subscription.items.find((item: any) => item.priceId === priceId).quantity
    const price = products.find((item) => item.prices.find((price: any) => price.id === priceId)).prices.find((item: any) => item.data.active === true).data.unit_amount;

    // if no phases, we need to get data from subscription
    if (phases.length === 0) {
      const finalQuantity = parseInt(isNaN(quantity) ? 0 : quantity) - (isNaN(addOnsToBeRemoved) ? 0 : addOnsToBeRemoved)
      return finalQuantity * price;
    }
    else { // if phases, we need to get data from the schedule.phases
      // Get quantities with fallback to 0 if undefined
      const lastItemQuantity: number = phases.at(-1)?.items.find((item: any) => item.price === priceId)?.quantity ?? 0;
      // totalQuantity = organization.userLimit - toBeRemovedFromSchedule - totalQuantity;
      const finalQuantity = lastItemQuantity - (isNaN(addOnsToBeRemoved) ? 0 : addOnsToBeRemoved)
      return finalQuantity * price;
    }
  }


  return (
    <>
      <Loader isVisible={isLoading} />
      {
        setAddOnRemoveComplete &&
        <div className={`${COMPONENT_CLASS}__container`}>
          {!showNextSlide && (
            <div>
              <div style={{ marginTop: "0.25rem" }}>
                <Dialog.Title
                  as="h2" className={`${COMPONENT_CLASS}__modal-title`}>
                  {t('addOns.removeService', { serviceName: serviceName })}
                </Dialog.Title>
              </div>
              <PortalProgressBar total={limit} currentProgress={count} headerText={t('addOns.usedTracking', { count: count, limit: limit, serviceName: serviceName })} />
              <div className={`${COMPONENT_CLASS}__remove-input-container`}>
                <p className={`${COMPONENT_CLASS}__remove-input-header`}>{t('addOns.serviceToRemove', { serviceName: serviceName })}</p>
                {/* <input
                  className={`${COMPONENT_CLASS}__remove-input`}
                  type='text'
                  value={addOnsToBeRemoved}

                  onBlur={((event) => {
                    if (event.target.value === '') {
                      setAddOnsToBeRemoved("1");
                    }

                  })
                  } onChange={((event) => {
                    setAddOnsToBeRemoved(event.target.value);
                    if (event.target.value !== '' && parseInt(event.target.value) <= quantity) {
                      setAddOnsToBeRemoved(event.target.value);
                    }
                    else if (event.target.value !== '' && parseInt(event.target.value) > quantity) {
                      setAddOnsToBeRemoved(quantity.toString());
                    }
                  })}></input> */}
                <NumberTypeInput
                  id='removeInput'
                  inputClassName={`${COMPONENT_CLASS}__remove-input`}
                  registerHook={register}
                  registerOptions={{
                    value: addOnsToBeRemoved,
                    min: "0",
                    max: quantity - existingAmountToBeRemoved,
                    onChange: (event) => {
                      preventRemoveOverMax(event)
                    }
                  }} />
              </div>
              <div>
                <p ><span className={`${COMPONENT_CLASS}__light-text-16`}>{t('addOns.changeAddOnDetails')}</span> <b className={`${COMPONENT_CLASS}__bold-text-16`}>{nextPayment}.</b> <span className={`${COMPONENT_CLASS}__light-text-16`}>{t('addOns.howYourAccountWillChange')}</span></p>
              </div>
              <div className={`${COMPONENT_CLASS}__remove-checkboxes`}>
                <div className={`${COMPONENT_CLASS}__remove-checkbox`}>
                  <CheckboxTypeInput
                    id='firstCondition'
                    checked={firstConditionChecked}
                    registerHook={register}
                    registerOptions={{
                      onChange: (() => { checkHandler(1); }),
                    }} />
                  <label className={`${COMPONENT_CLASS}__light-text`}
                    htmlFor="firstCondition">
                    <span className={`${COMPONENT_CLASS}__light-text`}>
                      {t('addOns.firstCondition', { serviceName: serviceName.toLowerCase() })}
                    </span>
                    <b className={`${COMPONENT_CLASS}__bold-text`}>{limit}</b>
                    <span className={`${COMPONENT_CLASS}__light-text`}>{t('addOns.to')}</span>
                    <b className={`${COMPONENT_CLASS}__bold-text`}>
                      {existingAmountToBeRemoved ? isNaN(parseInt(addOnsToBeRemoved)) ? hiddenLimit ? hiddenLimit : limit : limit - parseInt(addOnsToBeRemoved) - existingAmountToBeRemoved : isNaN(parseInt(addOnsToBeRemoved)) ? '' : limit - parseInt(addOnsToBeRemoved)}</b>
                    .</label>
                </div>
                {
                  ((hiddenLimit && parseInt(addOnsToBeRemoved) > hiddenLimit - count) || (!hiddenLimit && parseInt(addOnsToBeRemoved) > limit - count)) && (
                    <div className={`${COMPONENT_CLASS}__remove-checkbox`}>
                      <CheckboxTypeInput
                        id='secondCondition'
                        checked={secondConditionChecked}
                        registerHook={register}
                        registerOptions={{
                          onChange: (() => { checkHandler(2); }),
                        }} />
                      <label htmlFor="secondCondition">
                        <span className={`${COMPONENT_CLASS}__light-text`}>
                          {t('addOns.secondCondition_1', { serviceName: serviceName.toLowerCase() })}
                        </span>
                        <b className={`${COMPONENT_CLASS}__bold-text`}>
                          {existingAmountToBeRemoved && hiddenLimit ? parseInt(addOnsToBeRemoved) - (hiddenLimit - count) : parseInt(addOnsToBeRemoved) - (limit - count)}
                        </b>
                        <span className={`${COMPONENT_CLASS}__light-text`}>
                          {serviceName.toLowerCase()} {t('addOns.secondCondition_2')}
                        </span>
                      </label>
                    </div>
                  )

                }
                <div className={`${COMPONENT_CLASS}__remove-checkbox`}>
                  <CheckboxTypeInput
                    id='thirdCondition'
                    checked={thirdConditionChecked}
                    registerHook={register}
                    registerOptions={{
                      onChange: (() => { checkHandler(3); }),
                    }} />
                  <label className={`${COMPONENT_CLASS}__light-text`} htmlFor="thirdCondition"><span className={`${COMPONENT_CLASS}__light-text`}>{t('addOns.thirdCondition', { serviceName: serviceName.toLowerCase() })}</span> </label>
                </div>
              </div>
              <hr className={`${COMPONENT_CLASS}__remove-hr`} />
              <div className={`${COMPONENT_CLASS}__remove-information-container ${COMPONENT_CLASS}__light-text`}>
                <div className={`${COMPONENT_CLASS}__remove-information`}>
                  <p>{t('addOns.removeConfirm', { addOnsToBeRemoved: isNaN(addOnsToBeRemoved as any) ? 0 : addOnsToBeRemoved, serviceName: serviceName })}</p>
                  <p>-${(getTotalPricingByPriceId(addOnsToBeRemoved, priceId) / 100).toFixed(2)}</p>
                </div>
                {
                  existingAmountToBeRemoved > 0 && (
                    <div className={`${COMPONENT_CLASS}__remove-information`}>
                      <p>{t('addOns.previouslyRemoved', { serviceName: serviceName })}</p>
                      <p>{existingAmountToBeRemoved}</p>
                    </div>
                  )
                }

                <div className={`${COMPONENT_CLASS}__remove-information`}>
                  <p>{t('addOns.newLimit', { serviceName: serviceName })}</p>
                  <p>{isNaN(parseInt(addOnsToBeRemoved)) ? hiddenLimit ? hiddenLimit : limit : hiddenLimit ? hiddenLimit - parseInt(addOnsToBeRemoved) : limit - parseInt(addOnsToBeRemoved)}</p>
                </div>
                <div className={`${COMPONENT_CLASS}__remove-information`}>
                  <p>{t('addOns.newAddOnCost')}</p>
                  <p>${(getTotalPricingByPriceIdAndStripeQuantity(addOnsToBeRemoved, priceId) / 100).toFixed(2)}{t('pricing.general.month')}</p>
                </div>
                <hr className={`${COMPONENT_CLASS}__remove-hr`} />
              </div>
              <div className={`${COMPONENT_CLASS}__button-container`}>
                <Button
                  type='link'
                  buttonText={t('buttons.btn_keepAddOn')}
                  onClick={() => {
                    onClose();
                  }} />
                <Button
                  type="default"
                  disabled={!firstConditionChecked ||
                    !(secondConditionChecked || !((hiddenLimit && parseInt(addOnsToBeRemoved) > hiddenLimit - count) || (!hiddenLimit && parseInt(addOnsToBeRemoved) > limit - count))) ||
                    !thirdConditionChecked ||
                    (parseInt(addOnsToBeRemoved) < 1 || isNaN(parseInt(addOnsToBeRemoved)))}
                  buttonText={`${(hiddenLimit && parseInt(addOnsToBeRemoved) > hiddenLimit - count) || (!hiddenLimit && parseInt(addOnsToBeRemoved) > limit - count) ? t('buttons.btn_confirmRemove', { serviceName: serviceName }) : t('buttons.btn_confirmRemove')}`}
                  onClick={(async () => {
                    if ((hiddenLimit && parseInt(addOnsToBeRemoved) > hiddenLimit - count) || (!hiddenLimit && parseInt(addOnsToBeRemoved) > limit - count)) {
                      // User price id
                      if (priceId === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id) {
                        handleManageUserSlide();
                      }
                      // License price id
                      else if (priceId === products.find((item) => item.product.id === AddOnId.License).prices.find((item: any) => item.data.active === true).id) {
                        handleManageLicenseSlide();
                      }
                    }
                    else {
                      await handleRemove();
                    }
                  })} />
              </div>
            </div>
          )}
          {showManageUserSlide && setAddOnRemovedModalOpen && (
            <UserDeactivationModal
              openUserDeactivation={showManageUserSlide}
              setOpenUserDeactivation={setShowManageUserSlide}
              isLoading={false}
              organization={organization}
              deactivationAmount={hiddenLimit ? parseInt(addOnsToBeRemoved) - (hiddenLimit - count) : parseInt(addOnsToBeRemoved) - (limit - count)}
              removeAtFutureDate={true}
              addOnAmountToBeRemoved={parseInt(addOnsToBeRemoved)}
              organizationSubscription={orgSub}
              handleAddOnRemove={handleRemove}
              setAddOnRemovedModalOpen={setAddOnRemovedModalOpen}
              setRemovedAddOnInfo={setRemovedAddOnInfo}
            />
          )}
          {showManageLicenseSlide && setAddOnRemovedModalOpen && (
            <LicenseRemovalModal
              openLicenseRemoval={showManageLicenseSlide}
              setOpenLicenseRemoval={setShowManageLicenseSlide}
              isLoading={false}
              organization={organization}
              deactivationAmount={hiddenLimit ? parseInt(addOnsToBeRemoved) - (hiddenLimit - count) : parseInt(addOnsToBeRemoved) - (limit - count)}
              removeAtFutureDate={true}
              addOnAmountToBeRemoved={parseInt(addOnsToBeRemoved)}
              organizationSubscription={orgSub}
              handleAddOnRemove={handleRemove}
              setAddOnRemovedModalOpen={setAddOnRemovedModalOpen}
              setRemovedAddOnInfo={setRemovedAddOnInfo} />
          )}
        </div >
      }
      {
        setAddOnPurchaseComplete &&
        <div className={`${COMPONENT_CLASS}__container`}>
          {!showNextSlide && (
            <div>
              <p className={`${COMPONENT_CLASS}__extra-header`}>{t('addOns.addOn')}</p>
              <Dialog.Title
                as="h2" className={`${COMPONENT_CLASS}__modal-title`}>
                {serviceName}
              </Dialog.Title>
              <div className={`${COMPONENT_CLASS}__description`}>
                <div className={`${COMPONENT_CLASS}__description_container`}>
                  <div className={`${COMPONENT_CLASS}__description_container_description`}>
                    <p className={`${COMPONENT_CLASS}__light-text`} style={{ marginBottom: "0.5rem" }}>{description}</p>
                    <ul className={`${COMPONENT_CLASS}__description-list`} >
                      {descriptionBullets.map((bullet) => {
                        return (<li className={`${COMPONENT_CLASS}__light-text ${COMPONENT_CLASS}__description-list-item`} >{bullet}</li>)
                      })}
                    </ul>
                  </div>
                  <div className={`${COMPONENT_CLASS}__description_container_button`}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '1rem' }}>
                      <h1 style={{ fontSize: '30px', fontWeight: 'bold', marginRight: '0.5rem' }}>
                        +{USDollar.format(price)}
                      </h1>
                      <p className={`${COMPONENT_CLASS}__interval`} style={{ color: '#82848B' }}>{t('pricing.general.month')}</p>
                    </div>
                    <Button
                      buttonText={t('addOns.buttons.addToPlan')}
                      onClick={handleNextClick} />
                  </div>
                </div>
              </div>
            </div>
          )}
          {showNextSlide && (
            <div>
              <p className={`${COMPONENT_CLASS}__extra-header`}>{t('addOns.addOn')}</p>
              <Dialog.Title
                as="h2" className={`${COMPONENT_CLASS}__modal-title`}>
                {t('addOns.addService', { serviceName: serviceName })}
              </Dialog.Title>
              <div className={`${COMPONENT_CLASS}__summary`}>
                <div className={`${COMPONENT_CLASS}__summary_container`}>
                  <div className={`${COMPONENT_CLASS}__summary-description`}>
                    <p>{summaryDescription[0]} <b>{limit + quantity}</b> {summaryDescription[1]} <b>{USDollar.format(price)}</b> {summaryDescription[2]}</p>
                    <br />
                    <p>{t('addOns.firstChargeDetails')}</p>
                  </div>
                  <hr />
                  <p className={`${COMPONENT_CLASS}__summary-header`}>{t('addOns.summary')}</p>
                  <div className={`${COMPONENT_CLASS}__summary_container_pay-line`}>
                    <p>{quantity} {serviceName}(s)</p>
                    <p>{USDollar.format(fullRate!)}{t('pricing.general.month')}</p>
                  </div>
                  {refundedAmount! > 0 && (
                    <div className={`${COMPONENT_CLASS}__summary_container_pay-line`}>
                      <p>{t('addOns.proratedDiscount', { amountOfUnusedDays: amountOfUnusedDays })} {/* TODO: refund for X unused days: Date.now - period start*/}</p>
                      <p>-{USDollar.format(refundedAmount!)}</p>
                    </div>
                  )}
                  {proratedRate && proratedRate > 0 && (
                    <div className={`${COMPONENT_CLASS}__summary_container_pay-line`}>
                      <p className={`${COMPONENT_CLASS}__summary-total-due`} style={{ fontWeight: 'bold' }}>{t('addOns.totalDue')}</p>
                      <p>{USDollar.format(proratedRate)}</p>
                    </div>
                  )}

                  <hr />
                  <div className={`${COMPONENT_CLASS}__summary_container_button`}>
                    <Button
                      type='link'
                      buttonText={t('buttons.btn_cancel')}
                      onClick={() => {
                        onClose()
                      }} />
                    <Button
                      type="default"
                      buttonText={t('buttons.btn_purchase')}
                      onClick={handlePayment} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div >
      }
    </>
  );
};

export default AddOnDialogBox;